import { createContext, useContext } from "react";

import { LoadingIndicatorContextType } from "./LoadingIndicatorContextProvider.types.ts";

const LoadingIndicatorContext = createContext<LoadingIndicatorContextType>({} as LoadingIndicatorContextType);

export default LoadingIndicatorContext;

export const useLoadingIndicator = () => useContext(LoadingIndicatorContext);
